<template>
    <div class="google-map" ref="googleMap">
        <template v-if="Boolean(this.google) && Boolean(this.map)">
            <slot :google="google" :map="map"/>
        </template>
    </div>
</template>

<script>
import GoogleMapsApiLoader from "../../../vendor/google-maps-api-loader";

export default {
    props: {
        mapConfig: Object,
        apiKey: String
    },

    data() {
        return {
            google: null,
            map: null,
            isDragging: false,
            initialized: false,
        };
    },

    async mounted() {
        const googleMapApi = await GoogleMapsApiLoader({
            apiKey: this.apiKey,
            loadingTimeout: 29000
        });
        this.google = googleMapApi;
        this.initializeMap();
    },

    methods: {
        initializeMap() {

            console.log('');
            console.log('running initializeMap...');
          
            const vm = this;
            let newBounds = false;
            const mapContainer = this.$refs.googleMap;
            const mapOptions = {
              ...{
                fullscreenControlOptions: {
                  position: google.maps.ControlPosition.RIGHT_BOTTOM
                    }
                },
                ...this.mapConfig
            };
            console.log('-> Map Center:');
            console.log('--> Lat: ', typeof(mapOptions.center.lat), mapOptions.center.lat);
            console.log('--> Lng: ', typeof(mapOptions.center.lng), mapOptions.center.lng);
            console.log('-> Map Options: ', mapOptions);
            console.log('');

            if(!Math.abs(mapOptions.center.lat) || !Math.abs(mapOptions.center.lng)){
              return false;
            }

            this.map = new this.google.maps.Map(mapContainer, mapOptions);

            console.log('Property Search Map initialized successfully');
            console.log('');

            this.initialized = true;

            if(this.mapConfig.initialBounds.north &&
                this.mapConfig.initialBounds.south &&
                this.mapConfig.initialBounds.east &&
                this.mapConfig.initialBounds.west){
                newBounds = this.makeLatLngBounds(this.mapConfig.initialBounds);
                if(newBounds){
                    this.map.fitBounds(newBounds);
                }
            }

            /**
             *  When the map idles (this happens after any interaction with the map, and also after the location select input changes, which changes the center position of the map), 
             *  That fires this watcher. We need to get the bounds of the map so that they can go to the API as search parameters
             */
            google.maps.event.addListener(this.map, "idle", function(e) {

              let bounds = vm.map.getBounds();
              let center = vm.map.getCenter();
              console.log('google map idle event', center, bounds);
              let idleParams = { bounds: vm.map.getBounds() };

              vm.$emit("google-map-idle", idleParams);
              /**
               * This should only fire once. disable it.
               */
              google.maps.event.clearListeners(vm.map, 'idle');
            });

            /**
             * Triggered by user panning or zooming the map
             */
            google.maps.event.addListener(this.map, 'bounds_changed', function(e) {
              vm.$emit("google-map-bounds-changed", vm.map.getBounds());
            });

            google.maps.event.addListener(this.map, "dragstart", function() {
                vm.$emit("google-map-drag-start");
                vm.isDragging = true;
            });

            google.maps.event.addListener(this.map, "dragend", function() {
                vm.$emit("google-map-drag-end", {
                    center: vm.map.getCenter(), 
                    bounds: vm.map.getBounds()
                });
            });

        },

        makeLatLngBounds(bounds){
            try {
                let southWest = new this.google.maps.LatLng(bounds.south, bounds.west);
                let northEast = new this.google.maps.LatLng(bounds.north, bounds.east);
                let newBounds = new this.google.maps.LatLngBounds(southWest,northEast);
                return newBounds;
            } catch(e) {
                console.warn(e);
                return false;
            }
            return false;
        }

    },

    watch: {
        // This is used to re-center the map when the user selects a new location
        'mapConfig.zoom': function (val, oldVal) { 
            if(!this.map) {
                return false; // the second condition is there to prevnet an infinite loop
            }
            if(val == oldVal){
                 console.warn('=> zoom values did not change...')
                 return false;
             }
            this.map.setZoom(val);
         },
         // This is used to re-center the map when the user selects a new location
        'mapConfig.center': function (newCenter, oldCenter) { 
            const vm = this;
            if(!this.map) { console.warn('PropertySearchMapLoader :: invalid map'); return false; }
            if(!newCenter || !oldCenter) { console.warn('PropertySearchMapLoader :: invalid val'); return false; }
            if(!oldCenter) { console.warn('PropertySearchMapLoader :: invalid oldCenter'); return false; }
            let currentZoom = this.map.getZoom();
            let newOptions = {};

            console.log('mapConfig center changed', newCenter);
            console.log('');

            if(newCenter.lat != oldCenter.lat) { 
                newOptions.center = {
                    lat: this.mapConfig.center.lat,
                    lng: this.mapConfig.center.lng
                };
            }
            
            /**
             * If the map just got done doing a drag event, do not check the zoom. We dont want to adjust the zoom right after they dragged. Only when the location select input changes the center of the map
             */
            if(this.isDragging){
                console.warn('isDragging :: ignoring zoom check')
                this.isDragging = false;
            } else {
                // if(currentZoom != this.mapConfig.zoom) { 
                //     newOptions.zoom = this.mapConfig.zoom;
                // }
            }

            if(!newOptions.center && !newOptions.zoom) {
                // here to prevnet an infinite loop, among other things
                // console.log('');
                // console.warn('mapConfig.center watcher was fired with params equal to those it already had'); 
                // console.log('');
                return false;     
            }

            
            // change center and or zoom, if they were assigned
            this.map.setOptions(newOptions);
            
            // let bounds = vm.map.getBounds();
            // this.$emit("google-map-center-changed", bounds);
         },
         
         // This is used to re-center the map when the user selects a new location
         'mapConfig.draggable': function (draggable) { 
             if(!this.map) return false;
             this.map.setOptions({draggable});
          },
    }
};
</script>